import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { ARTICLE_SERVICE_CTA } from "@/content/seo/article-service-cta";

/**
 * Visas högst upp i en kunskapsartikel som rankar på kommersiell sökning,
 * så läsaren kan gå direkt till tjänstesidan i stället för att lämna sajten.
 */
export function ArticleServiceCta({ slug }: { slug: string }) {
  const cta = ARTICLE_SERVICE_CTA[slug];
  if (!cta) return null;

  return (
    <div className="mt-8 flex flex-col gap-3 rounded-2xl border border-mint/25 bg-mint/5 p-5 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-foreground/85">{cta.body}</p>
      <Link
        to={cta.to}
        className="inline-flex shrink-0 items-center gap-2 rounded-full bg-mint px-4 py-2 text-sm font-medium text-background transition-opacity hover:opacity-90"
      >
        {cta.label}
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
